import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'inpock-ui-react';

import { scale } from '@/utils';

interface HeaderProps {
  onClick: () => void;
  headerBgColor?: theme.ColorAlias;
  open?: boolean;
  removeBorder?: boolean;
  headerType?: 'default' | 'custom';
}

export const Header = styled.div<HeaderProps>`
  cursor: pointer;
  ${(props) => {
    if (props.headerBgColor) {
      return css`
        background-color: ${theme.colors[props.headerBgColor]};
      `;
    } else {
      return css`
        background-color: transparent;
      `;
    }
  }}

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: ${(props) =>
    props.headerType === 'custom'
      ? `${scale.large} ${scale.xsmall}`
      : `${scale.large} ${scale.medium}`};
  border-bottom: ${(props) =>
    !props.removeBorder && !props.open
      ? props.headerType === 'custom'
        ? `1px solid ${theme.colors.gray200}`
        : `1px solid ${theme.colors.gray100}`
      : ''};
`;

export const ChildrenScope = styled.div`
  flex-shrink: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .inpock-typography.paragraph-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  &:first-of-type {
    margin-bottom: 8px;
  }
`;

export const IconScope = styled.div`
  flex-shrink: 0;
  margin-left: 16px;
`;

export const Body = styled.div<{ open: boolean }>`
  display: ${(props) => (props.open ? 'block' : 'none')};
`;

export const Container = styled.div`
  width: 100%;
`;
